

























import Vue from "vue";
import { Component, Prop } from "vue-property-decorator";

@Component({})
export default class MobileHeader extends Vue {
  @Prop({ type: String, default: "" }) title!: string;
  @Prop({ type: String, default: "Volver" }) ariaLabel!: string;
}
